import { render, staticRenderFns } from "./WinterCollectionSizes.vue?vue&type=template&id=b58c80bc&scoped=true&"
import script from "./WinterCollectionSizes.vue?vue&type=script&lang=js&"
export * from "./WinterCollectionSizes.vue?vue&type=script&lang=js&"
import style0 from "./WinterCollectionSizes.vue?vue&type=style&index=0&id=b58c80bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b58c80bc",
  null
  
)

export default component.exports